import styled from 'styled-components';

export const Cupom = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    height: 28px;
    width: auto;
    padding: 0 8px;
    gap: 4px;
    border-radius: 28px;

    background-color: ${({ theme }) => theme.colors.tag.coupon};

    span {
        font-family: Inter;
        font-size: 12px;
        font-weight: 500;
        line-height: 14.52px;
        letter-spacing: 0.016em;
        text-align: left;
        color: ${({ theme }) => theme.colors.text.inverted};
    }

    img {
        height: 16px;
        width: 16px;
    }
`;

export const OGlobo = styled(Cupom)`
    background-color: ${({ theme }) => theme.colors.tag.oGlobo};
    white-space: nowrap;
`;

export const Partner = styled(Cupom)`
    background-color: ${({ theme }) => theme.colors.tag.socio};
    white-space: nowrap;
`;

export const Released = styled(Cupom)`
    background-color: ${({ theme }) => theme.colors.tag.codigo};
    white-space: nowrap;
`;

export const FaceEnabled = styled(Cupom)`
    background-color: ${({ theme }) => theme.colors.tag.face};
    white-space: nowrap;

`;

export const MandatoryBiometrics = styled(Cupom)`
    background-color: ${({ theme }) => theme.colors.tag.biometria};
    white-space: nowrap;
`;

export const Promotional = styled(Cupom)`
    background-color: ${({ theme }) => theme.colors.tag.promotional};
    white-space: nowrap;
`;
